import { StripeMessages } from "components/StripeMessages/StripeMessages";
import { useEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import { Box, MessageStripe, Stack } from "prism-react";

import { useGitHubScopes } from "hooks/useGitHubScopes";

import { TopBarItems } from "./TopbarItems";

export const TOPBAR_HEIGHT = 44 + "px";

const RestrictedPublicRepos: React.FC = () => {
  const gitHubScopes = useGitHubScopes();
  const project = useEditor();
  const [session, sessionApi] = useSession();

  if (
    session.state === "UNAUTHENTICATED" ||
    gitHubScopes?.publicRepos ||
    project.type !== "branch"
  ) {
    return null;
  }

  return (
    <MessageStripe variant="warning">
      <span>
        Adjust your GitHub permissions to{" "}
        {project.contribution
          ? "contribute to open source projects."
          : "access your repositories."}
      </span>
      <MessageStripe.MultiActions
        options={
          <>
            <MessageStripe.MultiActionsItem
              onSelect={() =>
                sessionApi.signIn({
                  type: "github",
                  includedScopes: "private_repos",
                })
              }
            >
              Access all repositories
            </MessageStripe.MultiActionsItem>
            <MessageStripe.MultiActionsItem
              onSelect={() =>
                sessionApi.signIn({
                  type: "github",
                  includedScopes: "public_repos",
                })
              }
            >
              Access only public repositories
            </MessageStripe.MultiActionsItem>
          </>
        }
        selfTrigger
      >
        Review GitHub permissions
      </MessageStripe.MultiActions>
    </MessageStripe>
  );
};

interface EditorLayoutProps {
  children: React.ReactNode;
  className?: string;
  isReady?: boolean;
}
export const EditorLayout: React.FC<EditorLayoutProps> = ({
  children,
  className,
  isReady,
}) => {
  return (
    <Stack
      className={className}
      css={{
        width: "100vw",
        height: "100vh",
        overflow: "clip",
        background: "$neutral-bg-base",
        position: "relative",
        zIndex: 1,
      }}
      gap={0}
    >
      {isReady && <StripeMessages />}
      {isReady && <RestrictedPublicRepos />}
      <Box
        css={{
          minHeight: TOPBAR_HEIGHT,
        }}
      >
        {isReady && <TopBarItems />}
      </Box>

      <Box
        css={{
          flex: 1,
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};
